import PageTitle from '../../components/PageTitle'
import ServiceTypesTab from './ServiceTypesTab'

/**
 * PACE → Service Types. Per-merchant service-type config for the PACE decision layer.
 * Split out of the old tabbed Allocation Config page. Internal/Tools only.
 */
export default function ServiceTypesPage() {
  return (
    <div>
      <PageTitle>PACE · Service Types</PageTitle>
      <ServiceTypesTab />
    </div>
  )
}
